

























import Vue, { PropType } from 'vue'

export default Vue.extend({
  name: 'HeaderGame',

  props: {
    score: Number,
    round: Number,
    remainingTime: Number,
  },

  computed: {
    countdownText(): string {
      let minutes: string | number = Math.floor(this.remainingTime / 60)
      let seconds: string | number = this.remainingTime % 60
      if (minutes < 10) {
        minutes = `0${minutes}`
      }
      if (seconds < 10) {
        seconds = `0${seconds}`
      }
      return `${minutes}:${seconds}`
    },
  },
})
